import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Marca } from '../componentes/Marca.tsx';
import { BotaoTema } from '../componentes/Tema.tsx';
import { Aviso, Botao, Campo, Cartao, Etiqueta } from '../componentes/ui/index.ts';
import { ErroApi } from '../lib/api.ts';
import { useSessao } from '../lib/sessao.tsx';

export function Entrar() {
  const { entrar, cadastrar } = useSessao();
  const [modo, setModo] = useState<'entrar' | 'cadastrar'>('entrar');

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function submeter(e: React.FormEvent) {
    e.preventDefault();
    setErro(null);
    setEnviando(true);

    try {
      if (modo === 'entrar') await entrar(email, senha);
      else await cadastrar(nome, email, senha);
      // Sem navegação aqui: o App redireciona sozinho conforme o status da
      // conta — aprovado vai ao painel, pendente vai à tela de espera.
    } catch (err) {
      setErro(
        err instanceof ErroApi
          ? modo === 'entrar'
            ? 'E-mail ou senha incorretos.'
            : err.mensagem
          : 'Erro inesperado.',
      );
      setEnviando(false);
    }
  }

  return (
    <div className="container container-form" style={{ paddingBlock: 'var(--gap-7)' }}>
      <header className="linha linha-entre" style={{ marginBottom: 'var(--gap-7)' }}>
        <Marca subtitulo="Painel" />
        <BotaoTema />
      </header>

      <main id="conteudo" className="pilha-5">
        <div className="pilha-3">
          <Etiqueta>Acesso restrito</Etiqueta>
          <h1>{modo === 'entrar' ? 'Entrar' : 'Criar acesso'}</h1>
        </div>

        <Cartao>
          <form className="pilha" onSubmit={submeter}>
            {modo === 'cadastrar' && (
              <Campo
                rotulo="Seu nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                autoComplete="name"
                required
                obrigatorio
              />
            )}

            <Campo
              rotulo="E-mail"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              obrigatorio
            />

            <Campo
              rotulo="Senha"
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              autoComplete={modo === 'entrar' ? 'current-password' : 'new-password'}
              required
              obrigatorio
              minLength={8}
              dica={modo === 'cadastrar' ? 'Mínimo de 8 caracteres.' : undefined}
            />

            {modo === 'cadastrar' && (
              <Aviso tipo="info">
                Criar a conta não libera o acesso. Um administrador precisa aprovar e definir seu
                nível de permissão antes de você conseguir usar o painel.
              </Aviso>
            )}

            {erro && <Aviso tipo="erro">{erro}</Aviso>}

            <Botao type="submit" tamanho="grande" largo carregando={enviando}>
              {modo === 'entrar' ? 'Entrar' : 'Criar acesso'}
            </Botao>

            <Botao
              type="button"
              variante="fantasma"
              largo
              onClick={() => {
                setModo(modo === 'entrar' ? 'cadastrar' : 'entrar');
                setErro(null);
              }}
            >
              {modo === 'entrar' ? 'Não tenho acesso ainda' : 'Já tenho conta'}
            </Botao>
          </form>
        </Cartao>

        <Link to="/" className="texto-fraco" style={{ textAlign: 'center' }}>
          ← Voltar para as inscrições
        </Link>
      </main>
    </div>
  );
}
